// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"VehicleModal_modalBody__3VJQv","modalFooter":"VehicleModal_modalFooter__EjZc7"};